// ** React Import
import { memo, useState } from 'react'

// ** MUI Import
import { Box, Button, Typography } from '@mui/material'
import CustomDialog from '../dialog'

// ** custom import
import AICreditUsageTab from '../../pages/subscription/components/AICreditUsageTab'

const ViewAITokenUsageMessage = ({ data = {} }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
        <Typography fontSize="13px">
          A total of <strong>{data?.credits || 0}</strong> credits {' '}
          {data?.month || data?.year
            ? `  was used for ${[data?.month, data?.year].filter(Boolean).join(',')}.`
            : 'use.'}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            display: 'block',
            mb: 1,
            lineHeight: 1.5
          }}
        >
          To see details usage click the below button
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          fullWidth
          onClick={() => setOpen(true)}
          sx={{
            textTransform: 'none',
            py: 0.5,
            borderRadius: 1,
            fontWeight: 600,
            fontSize: '12px'
          }}
        >
          View Details
        </Button>
      </Box>
      {open && (
        <CustomDialog
          open={open}
          title="AI Token Usage Credit History"
          handleClose={() => setOpen(false)}
          dialogPaperStyle={{
            width: '70%',
            maxWidth: '1000px',
            '& .MuiDialogContent-root': {
              paddingTop: '1px !important'
            }
          }}
        >
          <AICreditUsageTab
            fromDate={data?.fromDate || ''}
            toDate={data?.toDate || ''}
          />
        </CustomDialog>
      )}
    </>
  )
}

export default memo(ViewAITokenUsageMessage)
